/**
 * SnackbarHelper class provides utility methods to customize snackbar appearance.
 */
export class SnackbarHelper {

    /**
    * Returns the CSS class to be used for a success snackbar.
    * @returns {string} CSS class for the success snackbar.
    */
    public static snackbarPanelClassSuccess(): string {
        return 'snackbar-success';
    }
    /**
     * Returns the CSS class to be used for an error snackbar.
     * @returns {string} CSS class for the error snackbar.
     */
    public static snackbarPanelClassError(): string {
        return 'snackbar-error';
    }
}